export const getSamples = ({ samples }) => samples.samples;
export const getSampleMedia = ({ samples }) => samples.sampleMedia;
export const getIsolates = ({ samples }) => samples.isolates;
export const getClinicalSigns = ({ samples }) => samples.clinicalSigns;
